import { sessaoFetchLoading, sessaoFetch } from '@/service/fetch'

export async function cpf (cpf) {
  return false // sessaoFetchLoading(`base`, `/consulta/localizacao/${cpf}`)
}

export async function nome (dados) {
  return false // sessaoFetchLoading(`base`, `/consulta/localizacao/${dados.nome}/${dados.cidade}`)
}

export async function relacionados (cpf) {
  return sessaoFetchLoading(`base`, `/consulta/relacionados/${cpf}`)
}

export async function getRelacionados (cpf) {
  return sessaoFetchLoading(`base`, `/entidade/relacionados/${cpf}`, 'GET')
}

export async function beneficios (cpf) {
  return sessaoFetchLoading(`base`, `/consulta/beneficios/${cpf}`)
}

export async function extrato (beneficio) {
  let retorno = sessaoFetchLoading(`base`, `/consulta/extrato/${beneficio}`, 'GET', {}, false)
  return retorno
}

export async function extratoBase (beneficio) {
  return sessaoFetchLoading(`base`, `/consulta/base/${beneficio}`)
}

export async function extratoData (beneficio) {
  return sessaoFetchLoading(`base`, `/consulta/inss/${beneficio}`)
}

export async function hiscon (beneficio, loading = true) {
  if (loading) return sessaoFetchLoading(`base`, `/consulta/hiscon/${beneficio}`, 'GET', {}, false)
  return sessaoFetch(`base`, `/consulta/hiscon/${beneficio}`, 'GET', {}, false)
}

export async function historico (dados) {
  return []
}



// WEBPACK FOOTER //
// ./src/api/busca.js